import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-check
import { UploaderBlock } from '../../abstract/UploaderBlock.js';
import { asBoolean } from '../Config/normalizeConfigValue.js';
export class SimpleBtn extends UploaderBlock {
  constructor() {
    super();
    _defineProperty(this, "couldBeCtxOwner", true);
    this.init$ = _objectSpread(_objectSpread({}, this.init$), {}, {
      '*simpleButtonText': '',
      withDropZone: true,
      onClick: () => {
        this.initFlow();
      }
    });
  }
  initCallback() {
    super.initCallback();
    this.defineAccessor('dropzone', /** @param {unknown} val */
    val => {
      if (typeof val === 'undefined') {
        return;
      }
      this.$.withDropZone = asBoolean(val);
    });
    this.subConfigValue('multiple', val => {
      this.$['*simpleButtonText'] = val ? this.l10n('upload-files') : this.l10n('upload-file');
    });
  }
}
SimpleBtn.template = /* HTML */"\n  <lr-drop-area set=\"@disabled: !withDropZone\">\n    <button type=\"button\" set=\"onclick: onClick\">\n      <lr-icon name=\"upload\"></lr-icon>\n      <span>{{*simpleButtonText}}</span>\n      <slot></slot>\n      <div class=\"visual-drop-area\"></div>\n    </button>\n  </lr-drop-area>\n";
SimpleBtn.bindAttributes({
  // @ts-expect-error TODO: we need to update symbiote types
  dropzone: null
});